const cards = [
  {
    title: '《霸道总裁的契约新娘》',
    desc: '契约婚姻下的甜蜜爱情故事，韩漫热门连载。布丁漫画下拉式连续阅读，从第1话到最新128话流畅追更。',
    img: 'https://readdy.ai/api/search-image?query=A%20romantic%20digital%20illustration%20of%20an%20elegant%20couple%20in%20a%20modern%20office%20with%20warm%20sunlight%2C%20Korean%20manhwa%20art%20style%2C%20coral%20and%20peach%20color%20palette%2C%20soft%20romantic%20vibe%2C%20clean%20flat%20vector%20illustration&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '韩漫·恋爱',
    status: '连载中',
  },
  {
    title: '《剑与魔法的咏叹调》',
    desc: '异世界奇幻冒险日漫全集，魔法学院与龙骑士的史诗故事。布丁漫画全集免费阅读，一次性畅享完结作品。',
    img: 'https://readdy.ai/api/search-image?query=A%20fantasy%20digital%20illustration%20of%20a%20magical%20academy%20with%20floating%20castles%20and%20magic%20effects%2C%20Japanese%20manga%20art%20style%2C%20warm%20golden%20and%20amber%20color%20palette%2C%20adventurous%20atmosphere%2C%20clean%20vector%20illustration&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '日漫·奇幻',
    status: '已完结',
  },
  {
    title: '《修仙大佬在都市》',
    desc: '修仙者穿越到现代都市的搞笑热血故事，国漫头部连载。布丁漫画下拉式免费看，日更不断，已更新至205话。',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20illustration%20of%20a%20cultivator%20in%20modern%20city%20with%20energy%20powers%2C%20Chinese%20manhua%20art%20style%2C%20warm%20orange%20and%20golden%20color%20palette%2C%20action%20scene%2C%20clean%20flat%20vector%20illustration&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '国漫·修仙',
    status: '连载中',
  },
  {
    title: '《甜蜜的陷阱》',
    desc: '甜宠与悬疑完美结合的韩漫，每一话都充满反转。布丁漫画连续阅读模式让你停不下来，一口气追到大结局。',
    img: 'https://readdy.ai/api/search-image?query=A%20sweet%20and%20mysterious%20digital%20illustration%20of%20a%20couple%20with%20hidden%20secrets%20in%20a%20romantic%20setting%2C%20Korean%20webtoon%20art%20style%2C%20peach%20and%20rose%20color%20palette%2C%20intriguing%20atmosphere%2C%20clean%20vector%20illustration&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '韩漫·悬疑',
    status: '已完结',
  },
  {
    title: '《末日生存指南》',
    desc: '末日废土背景下的生存冒险国漫，硬核世界观搭配细腻人物刻画。布丁漫画下拉式免费阅读，第89话热更中。',
    img: 'https://readdy.ai/api/search-image?query=A%20post-apocalyptic%20digital%20illustration%20of%20survivors%20in%20a%20ruined%20city%20with%20dramatic%20lighting%2C%20Chinese%20manhua%20art%20style%2C%20warm%20amber%20and%20dark%20orange%20color%20palette%2C%20gritty%20atmosphere%2C%20clean%20vector%20illustration&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '国漫·末日',
    status: '连载中',
  },
  {
    title: '《重生之豪门千金》',
    desc: '重生复仇与豪门恩怨交织的韩漫长篇，人物关系错综复杂。布丁漫画全集免费看，剧情已进入最终章高潮。',
    img: 'https://readdy.ai/api/search-image?query=An%20elegant%20digital%20illustration%20of%20a%20sophisticated%20woman%20in%20a%20luxurious%20mansion%20setting%2C%20Korean%20manhwa%20art%20style%2C%20coral%20and%20gold%20color%20palette%2C%20dramatic%20and%20elegant%20atmosphere%2C%20clean%20flat%20vector%20illustration&width=600&height=400&seq=card-06&orientation=landscape',
    tag: '韩漫·豪门',
    status: '连载中',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            热门推荐
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            推荐漫画
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            布丁漫画网编辑精选热门漫画，支持布丁漫画下拉式连续阅读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                    card.status === '已完结'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-primary-100 text-primary-700'
                  }`}>
                    {card.status}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}